var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnFollow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_55854_136371)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.00047 6.41643C8.6113 6.41643 9.91713 5.1106 9.91713 3.49977C9.91713 1.88894 8.6113 0.583099 7.00047 0.583099C5.38964 0.583099 4.0838 1.88894 4.0838 3.49977C4.0838 5.1106 5.38964 6.41643 7.00047 6.41643Z",
    stroke: "#FE815F",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.75 12.8331C1.75 9.93361 4.10051 7.5831 7 7.5831C7.61361 7.5831 8.20264 7.68837 8.75 7.88184",
    stroke: "#FE815F",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 11.0001H8.16051",
    stroke: "#FE815F",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_55854_136371"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnFollow);
export default __webpack_public_path__ + "static/media/unFollow.dae8d57bfb2f31330ee3658859876dbd.svg";
export { ForwardRef as ReactComponent };